/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ player: NonNullable<unknown> }} Err_Tournament_Player_Not_In_SubsetInputs */



/**
* | output |
* | --- |
* | "Player {player} not in selected subset" |
*
* @param {Err_Tournament_Player_Not_In_SubsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_player_not_in_subset = /** @type {((inputs: Err_Tournament_Player_Not_In_SubsetInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Player_Not_In_SubsetInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le joueur ${i?.player} n'est pas dans le sous-ensemble sélectionné`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El jugador ${i?.player} no está en el subconjunto seleccionado`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`O jogador ${i?.player} não está no subconjunto selecionado`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il giocatore ${i?.player} non è nel sottoinsieme selezionato`)
	return /** @type {LocalizedString} */ (`Player ${i?.player} not in selected subset`)
});